export var surfaceBorderRadius = 'var(--_1igzksy0-3-15-1)';